<div class="info-popup">
  <header class="popup-header">
    <h2 class="popup-header__main">{{componentType | sensorHeader}}</h2>
    <ng-container [ngSwitch]="componentType">
      <h3 class="popup-header__sub" *ngSwitchCase="'dust'">Only in <span class="type">Awair</span></h3>
      <h3 class="popup-header__sub" *ngSwitchCase="'pm25'">Only in <span class="type">Omni</span></h3>
      <!-- <h3 class="popup-header__sub" *ngSwitchDefault></h3> -->
    </ng-container>
    <img class="popup-header__close" id="close-button" src="assets/images/timeline/info-popup/close.svg" (click)="closePopup()">
  </header>
  <div class="desc-wrapper">
    <section class="desc">
      <h3 class="desc-header">Know</h3>
      <p class="desc-body" [innerHTML]="componentType | knowDesc"></p>
    </section>
    <section class="desc" style="border-left: 1px solid #E9ECEE; border-right: 1px solid #E9ECEE;">
      <h3 class="desc-header">Conquer</h3>
      <p class="desc-body" [innerHTML]="componentType | conquerDesc"></p>
    </section>
    <section class="desc">
      <h3 class="desc-header">Breathe Easy</h3>
      <p class="be-desc-body" [innerHTML]="componentType | breatheEasyDesc"></p>
    </section>
  </div>
</div>